/*
 * Constants.
 */

export const stickyComposerToolbarClassName = 'front__composer-sticky-toolbar';
export const timelineScrollerClassName = 'front__timeline-scroller';
export const composerBaseScrollableDropzoneClassName = 'front__composer-base-dropzone-scroller';
export const commentComposerScrollEditorClassName = 'front__comment-composer-scroll-editor';
